{
  "REGISTER": {
    "TRY_WOOT": "Crear una cuenta",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Registrarse",
    "TESTIMONIAL_HEADER": "Todo lo que se necesita es un paso adelante",
    "TESTIMONIAL_CONTENT": "Usted está a un paso de involucrar a sus clientes, conservarlos y encontrar nuevos.",
    "TERMS_ACCEPT": "Al crear una cuenta, aceptas nuestros <a href=\"https://www.chatwoot.com/terms\">Términos y condiciones</a> y nuestra <a href=\"https://www.chatwoot.com/privacy-policy\">Política de privacidad</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registrarse con Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Nombre de la empresa",
      "PLACEHOLDER": "Introduce el nombre de tu empresa, por ejemplo: Wayne Enterprises",
      "ERROR": "El nombre de la cuenta es demasiado corto"
    },
    "FULL_NAME": {
      "LABEL": "Nombre completo",
      "PLACEHOLDER": "Introduce tu nombre completo, por ejemplo: Bruce Wayne",
      "ERROR": "El nombre completo es demasiado corto"
    },
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Introduzca su dirección de correo electrónico de trabajo. Por ejemplo, bruce{'@'}wayne{'.'}empresas",
      "ERROR": "Por favor, introduzca una dirección de correo válida"
    },
    "PASSWORD": {
      "LABEL": "Contraseña",
      "PLACEHOLDER": "Contraseña",
      "ERROR": "La contraseña es demasiado corta",
      "IS_INVALID_PASSWORD": "La contraseña debe contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmar contraseña",
      "PLACEHOLDER": "Confirmar contraseña",
      "ERROR": "Las contraseñas no coinciden."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
    },
    "SUBMIT": "Crear una cuenta",
    "HAVE_AN_ACCOUNT": "¿Ya tienes una cuenta?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Reenviar correo de verificación",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
